import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  buttonAddVersion: {
    backgroundColor: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 5,
    marginTop: '2%',
    marginLeft: '5%',
    border: '1px solid #dbdbdb',
    padding: 10,
    maxWidth: '25%',
    borderLeft: '4px solid #00A88F',
    cursor: 'pointer',
    color: '#008471',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.5)'
    }
  },
  subtitle: {
    fontSize: '0.9rem',
    marginLeft: 8,
    fontWeight: 'bold'
  },
  confirmButton: {
    width: 120,
    height: 35,
    marginLeft: '5%',
    backgroundColor: '#00A88F',
    cursor: 'pointer',

    borderRadius: '23px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#1BF57F'
    }
  },

  confirmButtonTypography: {
    color: '#FFFFFF',
    fontSize: 14,
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontStyle: 'normal',
    letterSpacing: '0.05em',
    lineHeight: '21px'
  },

  buttons: {
    position: 'absolute',
    bottom: 18,
    display: 'flex',
    marginLeft: '40%',
    flexDirection: 'row-reverse'
  },
  closeButton: {
    width: 90,
    height: 35,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  closeButtonColor: {
    color: '#263057',
    cursor: 'pointer',
    fontSize: 16,
    '&:hover': {
      color: '#1BF57F'
    },
    fontWeight: 700,
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    lineHeight: '23px'
  },
  buttonDeprecateVersion: {
    height: 28,
    width: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    background: '#f9f9f9',
    marginRight: 5,
    '&:hover': {
      backgroundColor: '#f2f2f2'
    },
    border: '2px solid #263057',
    borderRadius: '23px'
  },
  typographyButton: {
    fontFamily: 'Raleway',
    fontSize: '0.9em',
    letterSpacing: '0.05em',
    color: '#028B7E'
  }
}))

export default useStyles
